import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, Route, withRouter } from "react-router-dom";
import { ChangeLanguage } from "../../../../../../Actions/LanguageAction";
import TabContainer from "../../../../../../Component/Common/TabContainer";
import BankDetails from "./BankDetails/BankDetails";
import SigningAuthority from "./SigningAuthority";
import { GetFeature } from "../../../../../../Actions/commonAction";

class ConfigPayroll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      subscriptionid: null,
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("configpayroll,navigation");
    const {
      history: {
        location: { pathname = "" },
      },
    } = this.props;
    console.log("here", pathname);
    this.setState({
      value: !GetFeature("signatory") ? 1 : GetFeature("b") && this.props.history.location.pathname.includes("bank") ? 1 : 0,
    }, () => {
      if (GetFeature("signatory")) {
        pathname == "/config/pay/payroll/details"
        && this.props.history.push("./details/signatory");
      } else if (GetFeature("bankdetails")) {
        pathname == "/config/pay/payroll/details"
        && this.props.history.push("./details/bank");
      }
    });
  }

  handleChange = (event, value) => {
    this.setState({
      value: Number(value),
      subscriptionid: this.props.match.params.subscriptionid,
    }, () => {
      this.props.history.push(`./${value == 0 ? "signatory" : "bank"}`);
    });
  };

  render() {
    const { value } = this.state;
    const language = this.props.Language.configpayroll;
    const goTo = (path) => {
      this.props.history.push(path);
    };
    const { classes, match } = this.props;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <div>
            <div className="common-menubar-header">
              <Tabs
                value={value}
                onChange={this.handleChange.bind(this)}
                indicatorColor="primary"
                textColor="primary"
                scrollButtons="auto"
                // className='master-sh'
              >
                {GetFeature("signatory")
                && <Tab
                  disabled={!GetFeature("bankdetails")}
                  label={
                    <FormattedMessage id="TabSigningAuthority" defaultMessage="Signing Authority" />
                  }
                  className={`tabheading ${
                    this.props.history.location.pathname.includes("signatory") ? "active-tab1" : "inactive-tab1"
                  } `}
                />}
                {GetFeature("bankdetails")
                && <Tab
                  disabled={!GetFeature("signatory")}
                  label={<FormattedMessage id="TabBankDetails" defaultMessage="Bank Details" />}
                  className={`tabheading ${
                    this.props.history.location.pathname.includes("bank") ? "active-tab1" : "inactive-tab1"
                  } `}
                />}
              </Tabs>
              <div className="tab-border" />
            </div>
          </div>
          <div className="content-outer-wrapper-with-tab">
            <div className={classes.root}>
              {value === 0 && (
                <TabContainer>
                  <SigningAuthority {...this.props} goTo={goTo} />
                </TabContainer>
              )}
              {value === 1 && (
                <TabContainer>
                  <BankDetails {...this.props} goTo={goTo} />
                </TabContainer>
              )}
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(withRouter(ConfigPayroll))));
